import React, { useEffect, useState } from 'react'
import { ChevronRight } from 'lucide-react'
import { getlocalStorage } from '../Service/api/configuration/localstorage';


export default function DynamicBoxGrid({ subjects = [], onSubjectClick, onQtypeClick, type }) {
  const [selectedSubject, setSelectedSubject] = useState(null)
  const userData = getlocalStorage("userData");

  const handleSubjectClick = (subject) => {
    setSelectedSubject(subject?.id)
    if (onSubjectClick) {
      onSubjectClick("subject_id", subject)
    }

    if (onQtypeClick) {
      onQtypeClick(subject)
    }
  }

  useEffect(() => {
    setSelectedSubject(null)
  }, [subjects])

  return (
    <div className="w-full  mx-auto p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">


        {subjects?.map((subject) => (
          <button
            key={subject?.id}
            className={`flex items-center justify-between px-4 py-2 rounded-lg transition-colors ${selectedSubject === subject?.id
              ? 'bg-white text-blue-500 border border-blue-500'
              : 'bg-white text-gray-800 hover:bg-gray-200'
              }`}
            onClick={() => handleSubjectClick(subject)}
          >
            <span className="text-left font-medium">
              {type === "qtype"
                ? subject?.boardQtype?.length
                  ? (
                    subject.boardQtype.find(
                      (item) =>
                        item?.board_id === userData?.board_id &&
                        item?.medium_id === userData?.medium_id
                    )?.qtype || subject?.name
                  )
                  : subject?.name
                : subject?.subject}
            </span>
            <ChevronRight className="w-5 h-5" />
          </button>
        ))}
      </div>
    </div>
  )
}